import { render, staticRenderFns } from "./selector-provincias.vue?vue&type=template&id=27bd6d01&scoped=true&"
import script from "./selector-provincias.vue?vue&type=script&lang=ts&"
export * from "./selector-provincias.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd6d01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
